import * as React from "react";

import { cn } from "@/lib/utils";

type ContainerProps = {
  as?: React.ElementType;
  size?: "default" | "narrow" | "wide";
  className?: string;
  children: React.ReactNode;
};

export function Container({
  as: Component = "div",
  size = "default",
  className,
  children,
}: ContainerProps) {
  return (
    <Component
      className={cn(
        "mx-auto w-full px-5 sm:px-8 lg:px-12",
        {
          "max-w-7xl": size === "default",
          "max-w-5xl": size === "narrow",
          "max-w-[1440px]": size === "wide",
        },
        className,
      )}
    >
      {children}
    </Component>
  );
}
